import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import cx from 'classnames';
import _ from 'underscore';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { useIsMobile } from '../../hooks/useIsMobile';
import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const socialMediasList = [
	{
		name: 'vk',
		title: 'Поделиться в Вконтакте',
		color: 'blue',
		baseUrl: 'https://vk.com/share.php?url='
	},
	{
		name: 'odnoklassniki',
		title: 'Поделиться в Одноклассниках',
		color: 'mustard',
		baseUrl: 'https://connect.ok.ru/offer?url='
	},
	{
		name: 'whatsapp',
		title: 'Поделиться в Whatsapp',
		color: 'secondary-dark',
		baseUrl: 'https://api.whatsapp.com/send?text='
	},
	{
		name: 'share-link',
		title: 'Поделиться ссылкой',
		color: 'primary'
	}
];

const SocialMediaLinks = ({ titleText, shortText }) => {
	const [isTooltipActive, setIsTooltipActive] = useState(false);
	const isMobile = useIsMobile();
	const { asPath } = useRouter();

	const link = `${publicRuntimeConfig.baseUrl}${asPath}`;

	const shareLink = () => {
		const copyLink = () => navigator.clipboard.writeText(link);
		if (isMobile) {
			copyLink();
			return (
				navigator.share &&
				navigator.share({
					title: titleText,
					text: shortText,
					url: link
				})
			);
		}

		setIsTooltipActive(!isTooltipActive);
		return copyLink();
	};

	useEffect(() => {
		if (isTooltipActive) {
			setTimeout(() => setIsTooltipActive(false), 3000);
		}
		return () => {
			clearTimeout();
		};
	}, [isTooltipActive]);

	return (
		<div className={styles.container}>
			{_.initial(socialMediasList).map(({ name, title, color, baseUrl }) => (
				<a
					key={name}
					className={styles.iconWrapper}
					title={title}
					href={`${baseUrl}${link}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					<div className={cx(styles.background, styles[`theme_${color}`])} />
					<Icon icon={name} className={styles.icon} />
				</a>
			))}
			{[_.last(socialMediasList)].map(({ name, title, color }) => (
				<div key={name} className={styles.shareLinkContainer}>
					<div
						className={cx(styles.tooltipContainer, {
							[styles.isActive]: isTooltipActive
						})}
					>
						Ссылка скопирована
					</div>
					<button
						title={title}
						type="button"
						className={styles.iconWrapper}
						onClick={shareLink}
					>
						<div className={cx(styles.background, styles[`theme_${color}`])} />
						<Icon icon={name} className={styles.icon} />
					</button>
				</div>
			))}
		</div>
	);
};

SocialMediaLinks.propTypes = {
	titleText: PropTypes.string.isRequired,
	shortText: PropTypes.string.isRequired
};

export default SocialMediaLinks;
